import { ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';

export enum CaseQueryResultStatus {
  Paused = 'paused',
  Pending = 'pending',
  InProgress = 'in-progress',
  Completed = 'completed',
  Errored = 'errored',
}

export const CASE_QUERY_RESULT_TERMINAL_STATUSES = [
  CaseQueryResultStatus.Completed,
  CaseQueryResultStatus.Errored,
  CaseQueryResultStatus.Paused,
];

export interface CaseQueryResultAttributes {
  name: string; // name of corresponding case query
  result: any; // TODO: figure out a better typing, string or JSON of table format, e.g { 'header': ['header_1', 'header_2'], rows: [ ['cell_1', 'cell_2'], ['cell_3', 'cell_4'] ] }
  status: CaseQueryResultStatus;

  'started-at'?: string;
  'completed-at'?: string;
  'errored-at'?: string;
}

export interface CaseQueryResultRelationships {
  'case-query': ApiRelationship<ApiModel.CaseQuery>;
  case: ApiRelationship<ApiModel.Case>;
}

export type CaseQueryResult = ApiResource<
  CaseQueryResultAttributes,
  CaseQueryResultRelationships,
  ApiModel.CaseQueryResult
>;
